var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "19px",
    height: "19px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-50.00%",
    y: "-50.00%",
    width: "200.00%",
    height: "200.00%",
    filterUnits: "objectBoundingBox",
    id: "filter100"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0.955555555555555  0 1 0 0 0.955555555555555  0 0 1 0 0.955555555555555  0 0 0 1 0  ",
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -601 -20 )"
  }, /*#__PURE__*/React.createElement("image", {
    preserveAspectRatio: "none",
    style: {
      overflow: "visible"
    },
    width: 19,
    height: 19,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAAEzo7pQAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAGUExURQAAAAAAAKVnuc8AAAABdFJOUwBA5thmAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAnklEQVQoU52OURLEMAhCm/tfekViRWP6sexMFx7Y6UMt++EZbhCxP9/NNlJBYf79V2danl7ECJG3bYloFew2kIzh+m05ddVFv6FNEiZITkkyk2gGqTmuUvaBhSAooU0SJkhOSTKTaHZyfpKI5XWSxTip8JicN4WMr0w615A39xqy9qv2/mOxu9tE+DRprE+GE0XTG02BLzXE6lpD6/kBfVsAteen7BkAAAAASUVORK5CYII=",
    x: "601px",
    y: "20px",
    filter: "url(#filter100)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.de125bd1e1b60e8d2d6119b27956ea5b.svg";
export { ForwardRef as ReactComponent };